import styled, { css, keyframes } from 'styled-components';
import { Flex } from '../../ui-components/Flex/Flex';

export const StyledEditorWrapper = styled.div`
  position: relative;
  flex-grow: 1;
  background: black;
`;

export const StyledControllersWrapper = styled.div`
  position: absolute;
  top: 16px;
  left: 16px;
  gap: 16px;
  display: flex;
`;

export const StyledLoadingContentBox = styled(Flex)`
  background: white;
  padding: 40px;
  width: 500px;
  height: 450px;
`;

export const StyledLoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  background: rgba(200, 200, 200, 0.1) url(/img/login-bg.svg) no-repeat right
    center;
  background-size: auto 100%;
  svg {
    width: 48px;
    height: 48px;
    stroke: ${({ theme }) => theme.color('#676570')};
  }
`;

export const StyledCardWrapper = styled.div<{
  numberOfSlides: number;
}>`
  display: grid;
  place-items: center;
  width: 100vw;
  height: 100vh;
  ${({ numberOfSlides }) =>
    numberOfSlides &&
    css`
      grid-template-columns: repeat(${numberOfSlides}, 1fr);
    `}
`;

export const StyledFrameImage = styled.img`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 10;
`;

export const StyledSLideRendererPlaceholder = styled(Flex)`
  color: white;
  background-color: black;
  font-size: 1.3rem;
  font-weight: 600;
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`;

export const SlideContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const SlideLoadingPlaceholder = styled.div`
  position: absolute;
  inset: 0;
  background-color: #000000;
  animation: ${pulse} 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
`;

export const StyledSlideImage = styled.img<{
  $loaded: boolean;
}>`
  object-fit: contain;
  height: 100%;
  width: 100%;
  opacity: ${(props) => (props.$loaded ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
`;
